import type { ComponentProps, FC } from "react";

import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { AlertPageContainer } from "../../../ui/alert-page-container";

import { SelectTrademarkIcon } from "./select-trademark.svg";

export const EmptyTrademarkState: FC<ComponentProps<typeof Stack>> = (props) => {
    const translate = useTranslation();
    return (
        <AlertPageContainer {...props}>
            <SelectTrademarkIcon />
            <Stack
                alignItems="center"
                justifyContent="center"
            >
                <Text fontVariant="subtitle1">
                    {translate("monitor_and_protect.shared.empty_states.select_trademark.title")}
                </Text>
                <Text fontVariant="caption">
                    {translate("monitor_and_protect.shared.empty_states.select_trademark.subtitle")}
                </Text>
            </Stack>
        </AlertPageContainer>
    );
};
